var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 5.33339L2.66675 10.6667V13.3334L5.33341 13.3334L10.6667 8.00005M8.00008 5.33339L9.9125 3.42095L9.91365 3.41982C10.1769 3.15657 10.3088 3.0247 10.4608 2.97532C10.5947 2.93181 10.7389 2.93181 10.8728 2.97532C11.0247 3.02467 11.1564 3.15638 11.4193 3.41926L12.5792 4.57913C12.8432 4.84314 12.9752 4.97521 13.0247 5.12742C13.0682 5.26132 13.0682 5.40555 13.0247 5.53944C12.9753 5.69155 12.8434 5.82342 12.5797 6.08706L12.5792 6.08762L10.6667 8.00005M8.00008 5.33339L10.6667 8.00005",
    stroke: "#435B37",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.aaedbe7d3be70462074ae2e0000e2f02.svg";
export { ForwardRef as ReactComponent };